<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    width="550px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @ok="formHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div class="stop-cloud-tip">
      <p>{{ $t('message["747"]') }}</p>
    </div>
    <div class="creat-dilog-form">
      <a-form
        ref="createForm"
        :form="form"
        :hide-required-mark="true"
        class="stop-cloud-form"
      >
        <a-form-item
          :label="`${privateTitTxt}：`"
        >
          <a-input
            v-decorator="[
              'public-key',
              {rules: [{ required: true, message: publicKeyTit }], initialValue:'' }
            ]"
            disabled
            type="text"
            :placeholder="publicKeyTit"
          />
          <input
            ref="input"
            style="display: none;"
            type="file"
            accept="text/key"
            @change="upload(this)"
          >
          <a-button
            class="ml-16"
            @click="clickHandle"
          >
            {{ $t('message["986"]') }}
          </a-button>
        </a-form-item>
        <a-form-item
          :label="`${privateKeyTitTxt}：`"
        >
          <a-input
            v-decorator="[
              'private-key',
              {rules: [{ required: true, message: privateKeyTit }], initialValue:'' }
            ]"
            disabled
            type="text"
            :placeholder="privateKeyTit"
          />
          <input
            ref="input2"
            style="display: none;"
            type="file"
            accept="text/key"
            @change="upload2(this)"
          >
          <a-button
            class="ml-16"
            @click="clickHandle2"
          >
            {{ $t('message["986"]') }}
          </a-button>
        </a-form-item>
      </a-form>
      <progress-tip
        ref="progressTip"
        :count="count"
      />
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ProgressTip from './ProgressTip'
export default {
  components: {
    ProgressTip
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      rawData: '',
      publicData: '',
      privateData: '',
      count: 0
    }
  },
  computed: {
    ...mapState('organization/cloud', ['']),
    cid () {
      return this.$route.query.cid
    },
    privateTitTxt () {
      return this.$t('message["388"]')
    },
    publicKeyTit () {
      return this.$t('message["745"]')
    },
    privateKeyTit () {
      return this.$t('message["746"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    privateKeyTitTxt () {
      return this.$t('message["1146"]')
    },
    modalTit () {
      return this.$t('message["1205"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('organization/cloud', ['stopCloud']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const formDatas = {
            cid: this.cid * 1,
            'public-key': this.publicData,
            'private-key': this.privateData
          }
          const chain = await this.stopCloud(formDatas)
          chain.params(formDatas)
            .onSuccess(res => {
              this.privateData = ''
              this.publicData = ''
              this.$refs.input.value = ''
              this.$refs.input2.value = ''
              this.form.resetFields()
              this.isLimitDialogShow = false
              this.count = res.count
              this.$refs.progressTip.changeLimitDialog(true)
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    clickHandle () {
      const element = this.$refs.input
      this.eventMethod(element)
    },
    eventMethod (element) {
      if (document.createEvent) {
        const event = document.createEvent('MouseEvents')
        event.initEvent('click', false, true)
        element.dispatchEvent(event)
      } else if (document.createEventObject) {
        element.fireEvent('onclick')
      }
    },
    uploadMethods (data, ele) {
      if (window.FileReader) {
        var file = ele.files[0]
        var reader = new FileReader()
        reader.onload = () => {
          data = reader.result
          console.log(data)
        }
        reader.readAsText(file)
      }
    },
    upload () {
      const { input } = this.$refs
      if (window.FileReader) {
        var file = input.files[0]
        var reader = new FileReader()
        reader.onload = () => {
          this.publicData = reader.result
          console.log(this.publicData)
          this.form.setFieldsValue({ 'public-key': this.$t('message["389"]') + '****************************' })
        }
        reader.readAsText(file)
      }
    },
    upload2 () {
      const { input2 } = this.$refs
      if (window.FileReader) {
        var file = input2.files[0]
        var reader = new FileReader()
        reader.onload = () => {
          this.privateData = reader.result
          console.log(this.privateData)
          this.form.setFieldsValue({ 'private-key': this.$t('message["389"]') + '****************************' })
        }
        reader.readAsText(file)
      }
    },
    clickHandle2 () {
      const element = this.$refs.input2
      this.eventMethod(element)
    }
  }
}
</script>
<style lang="scss" scoped>
  .stop-cloud-form::v-deep {
    .ant-row {
    padding-left: 80px;
    .ant-input-number{
      width:160px;
    }
    .ant-form-item-label {
      float: left;
      width: 60px;
      margin-left: -80px;
      label {
      color: #666;
      }
    }
    .ant-form-item-control-wrapper {
      float: left;
      width: 100%;
    }
  }
  }
  .stop-cloud-tip {
    margin: -24px -24px 40px;
    padding: 0 30px 0;
    color: #F6A953;
    background: #FFF4E7;
    line-height: 40px;
  }
</style>
